import React, { useEffect, useState } from 'react';
import axios from 'axios';
import AppStrings from '../config/appstring';
import GenderSelect from '../Class/Gender';

const StaffMast = ({user}) => {
  const [data, setData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');
  const [feeDetails, setFeeDetails] = useState([]);
  const [admissionDate, setAdmissionDate] = useState(new Date().toISOString().split('T')[0]);
  const [ID, setID] = useState('');
  const [Type,SetType]=useState('');
const [selectedStudents, setSelectedStudents] = useState([]);
const [Studdata, setStuddata] = useState([]);
const [Studdata1, setStuddata1] = useState([]);

  const [search1, setSearch1] = useState('');

  useEffect(() => {
   
console.log("Logged in as:", user?.name);
    fetchStudentData();
   // fetchStudentAssignData();
    if (Type === 'Assign') {
    setSelectedStudents([]); 
  }
  }, [user,Type]);


  const employeeTypes = [
  { value: 'PARMANENT', label: 'PARMANENT' },
  { value: 'TEMPORARY', label: 'TEMPORARY' },
  { value: 'CONTRACT', label: 'CONTRACT' },
 
];
  
const getColor = (employeType) => {
  switch (employeType) {
    case 'PARMANENT':
    case 'PARMANENT':
      return '#6da9f8ff';  // green
    case 'TEMPORARY':
      return '#e74d9dff'; // some red-ish color
    case 'CONTRACT':
      return '#a0920eff';  // example: blue
    default:
      return '#000000';  // default black
  }
};

  const fetchStudentData = async () => {
    try {
      const response = await axios.get(AppStrings.StaffEntryReport);
      const result = response.data.data.result || response.data.data;
console.log(result,'zzzzzzzzzzz');
      if (Array.isArray(result)) {
        setData(result);
        setError('');
      } else {
        setError('Unexpected response format');
        console.warn('Expected an array but got:', result);
      }
    } catch (err) {
      setError('Failed to fetch data');
      console.error("Fetch error:", err.message || err);
    } finally {
      setLoading(false);
    }
  };

    const fetchStudentAssignData = async () => {
    try {
      const response = await axios.get(AppStrings.OverAllStudentDetails);
      const result = response.data.data.result || response.data.data;
console.log(result,'111zzzzzzzzzzz');
      if (Array.isArray(result)) {
        setStuddata(result);
        setError('');
      } else {
        setError('Unexpected response format');
        console.warn('Expected an array but got:', result);
      }
    } catch (err) {
      setError('Failed to fetch data');
      console.error("Fetch error:", err.message || err);
    } finally {
      setLoading(false);
    }
  };

   const fetchStudentAssignData1 = async () => {
    try {
      //Studdata1([]);
      console.log(ID,'ID....');
      const response1 = await axios.get(AppStrings.StaffStudentAssignList+`?STAFFID=${ID}`);
      const result1 = response1.data.data.result1 || response1.data.data;
console.log(response1.status,'222zzzzzzzzzzz');

      if (Array.isArray(result1)) {
        setStuddata1(result1);
        setError('');
      } else {
         setStuddata1([]);
        setError('Unexpected response format');
        console.warn('Expected an array but got:', result1);
      }
    } catch (err) {
       setStuddata1([]);
      setError('Failed to fetch data');
      console.error("Fetch error:", err.message || err);
    } finally {
      setLoading(false);
    }
  };

const formatDate = (dateString) => {
  if (!dateString) return '';
  
  const d = new Date(dateString);

  if (isNaN(d)) return '';

  // Adjust for timezone offset if needed
  const year = d.getFullYear();
  const month =String(d.getDate()).padStart(2, '0');
  const day =  String(d.getMonth() + 1).padStart(2, '0');

  return `${year}-${month}-${day}`;
};
  const handlePayClick = async (row) => {
    console.log(row.ID);
    setID(row.ID);
    console.log(ID,'ID-SET');
    if (!row.ID) {
      alert('Missing Id..!');
      return;
    }
SetType('Update');
     setSelectedRow(row);
console.log(row,'sssssss');
      setFormData({
    SHIFT: row.ACTIVE || "Y",
    FNAME: row.NAME || '',
    LNAME: row.LASTNAME || '',
    GENDER: row.GENDER || '',
    DOB: formatDate(row.DOB) || '',
    NUMBER: row.CONTACTNO || '',
    ADDRESS1: row.ADDRESS1 || '',
    ADDRESS2: row.ADDRESS2 || '',
    CITY: row.CITY || '',
    PINCODE: row.PINCODE || '',
    POSITION: row.ROLE || '',
    DEPARTMENT: row.DEPARTMENT || '',
    SUBJECTS: row.SUBJECTS || '',
    DOJ: formatDate(row.DOJ) || '',
    EMPLOYEETYPE: row.EMPLOYETYPE || ''
  });

    
  };

  const handleAssignClick = async (row) => {
    console.log(row.ID);
    setID(row.ID);
    console.log(ID,'ID-SET');
    fetchStudentAssignData();
    fetchStudentAssignData1();
    if (!row.ID) {
      alert('Missing Id..!');
      return;
    }
SetType('Assign');
setSelectedStudents([]); 
     setSelectedRow(row);
//console.log(row,'sssssss');
    
    
  };

   const handleCheckboxChange = (studentId) => {
    setSelectedStudents((prev) =>
      prev.includes(studentId)
        ? prev.filter((id) => id !== studentId)
        : [...prev, studentId]
    );
  };
  const handleInputChange = (index, field, value) => {
    const updated = [...feeDetails];
    updated[index][field] = value;
    setFeeDetails(updated);
  };

  const handleCancel = () => {
    setSelectedRow(null);
    setFeeDetails([]);
  };

  const [errors, setErrors] = useState({});
   const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: '', // clear error when typing
    }));
  };    

  const totalPaid = feeDetails.reduce((sum, fee) => sum + (parseFloat(fee.current) || 0), 0);


  //  const [firstName, setFirstName] = useState("");
  //       const [lastName, setLastName] = useState("");

  const handleAddNew = () => {
  setSelectedRow({}); // Just to trigger the modal open

  // Reset ID
  setID('');
SetType('Update');
  // Clear form fields
  setFormData({
    SHIFT: '',
    FNAME: '',
    LNAME: '',
    GENDER: '',
    DOB: admissionDate,
    NUMBER: '',
    ADDRESS1: '',
    ADDRESS2: '',
    CITY: '',
    PINCODE: '',
    POSITION: '',
    DEPARTMENT: '',
    SUBJECTS: '',
    DOJ: admissionDate,
    EMPLOYEETYPE: ''
  });

  // Optional: clear feeDetails if needed
  setFeeDetails([]);
};
        
    const handleSubmit = async () => {
      const payload = {
        STAFF: {
          ID: ID,
          ACT: formData.SHIFT,
          SHIFT: 'Y' ,
  NAME:formData.FNAME,LASTNAME:formData.LNAME,GENDER:formData.GENDER,DOB:formData.DOB,CONTACTNO:formData.NUMBER,ADDRESS1:formData.ADDRESS1,
  ADDRESS2:formData.ADDRESS2,CITY:formData.CITY,PINCODE:formData.PINCODE,ROLE:formData.POSITION,DEPARTMENT:formData.DEPARTMENT,
  SUBJECTS:formData.SUBJECTS,
  DOJ:formData.DOJ,EMPLOYEETYPE:formData.EMPLOYEETYPE
        },
      };
  
      try {
        console.log(payload,'NameList');
        //const res = await fetch("https://school.agnisofterp.com/agni/testing/entry", {
          const res = await fetch(AppStrings.StaffEntry, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        });
  
        const result = await res.json();
        console.log('haiiii22');
        alert(result.message || "Data saved successfully!");
        handleCancel();
        fetchStudentData();
        console.log('haiiii33');
      } catch (err) {
        console.error("Error:", err);
        alert("Failed to save data.");
      }
    };

    const [formData, setFormData] = useState({
  SHIFT: 'Y' ,
  FNAME:'',LNAME:'',GENDER:'',DOB:'',NUMBER:'',ADDRESS1:'',ADDRESS2:'',CITY:'',PINCODE:'',POSITION:'',DEPARTMENT:'',SUBJECTS:'',
  DOJ:'',EMPLOYEETYPE:''
});
    const handleShiftChange = (e) => {
  setFormData(prev => ({ ...prev, SHIFT: e.target.value }));
};


 const handleSelectAllChange = (e) => {
    if (e.target.checked) {
      const allIds = Studdata
        .filter((row) =>
          row.NAME.toLowerCase().includes(search1.toLowerCase()) ||
          row.STUDENT_ID.toLowerCase().includes(search1.toLowerCase())
        )
        .map((row) => row.STUDENT_ID);
      setSelectedStudents(allIds);
    } else {
      setSelectedStudents([]);
    }
  };

   const handleSelectAllChange1 = (e) => {
    if (e.target.checked) {
      const allIds = Studdata1
        .filter((row) =>
          row.NAME.toLowerCase().includes(search1.toLowerCase()) ||
          row.STUDENT_ID.toLowerCase().includes(search1.toLowerCase())
        )
        .map((row) => row.STUDENT_ID);
      setSelectedStudents(allIds);
    } else {
      setSelectedStudents([]);
    }
  };

  const handleStudentSubmit = async () => {
    const studentsToSubmit = Studdata.filter((student) =>
      selectedStudents.includes(student.STUDENT_ID)
    );
  
    const payload = studentsToSubmit.map((student) => ({
     
        ID: student.STUDENT_ID,
      // or remove this key entirely if not needed
    }));

    
  
    if (payload.length === 0 || formData.CLASS2==="") {
      alert("No valid student fee data to submit.");
      return;
    }
  
    try {
let student=[{"STAFFID":"","TYPE":"","STUDENT":[]}];
student[0].STUDENT.push(payload);
student[0].STAFFID=selectedRow.ID;
student[0].TYPE="I";

    console.log(student[0],'zzzzzzz')
      const res = await fetch(AppStrings.StaffStudentAssign, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(student[0]),
        
      });
  
      const result = await res.json();
      alert(result.message || "Student Assign successfully!");
      handleCancel();
    } catch (err) {
      console.error("Error:", err);
      alert("Failed to save data.");
    }
  };

   const handleStudentSubmit1 = async () => {
    const studentsToSubmit = Studdata1.filter((student) =>
      selectedStudents.includes(student.STUDENT_ID)
    );
  
    const payload = studentsToSubmit.map((student) => ({
     
        ID: student.STUDENT_ID,
      // or remove this key entirely if not needed
    }));

    
  
    if (payload.length === 0 || formData.CLASS2==="") {
      alert("No valid student fee data to submit.");
      return;
    }
  
    try {
let student=[{"STAFFID":"","TYPE":"","STUDENT":[]}];
student[0].STUDENT.push(payload);
student[0].STAFFID=selectedRow.ID;
student[0].TYPE="D";

    console.log(student[0],'zzzzzzz')
      const res = await fetch(AppStrings.StaffStudentAssign, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(student[0]),
        
      });
  
      const result = await res.json();
      alert("Student Cancel To Assign successfully!");
      handleCancel();
    } catch (err) {
      console.error("Error:", err);
      alert("Failed to save data.");
    }
  };



  return (
    <div style={{ padding: '0px' }}>
      <h2>Staff Details</h2>

      {loading && <p>Loading data...</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}

      <div className="row">
        <div className="col-25">
          <div className="coolinput">
            <input
              type="text"
              placeholder="Search By Staff Name / Phone No."
              name="STUDENTNAME"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              autoComplete="off"
              className="input"
            />
            <br />
          </div>
        </div>
         <div className="col-75">
        <div style={{ textAlign: 'right' }}>
             <button  onClick={handleAddNew} style={MastAddNewBtn}>Add New</button>
            <br />
          </div>
        </div>
      </div>

      {!loading && !error && Array.isArray(data) && (
        <div style={{ maxHeight: 'calc(100vh - 240px)', overflowY: 'auto', border: '1px solid #ccc' }}>
    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ backgroundColor: '#f2f2f2' }}>
                <th style={{ ...headerCellStyle, width: '10px' }}>ID</th>
                <th style={{ ...headerCellStyle, width: '300px' }}>First Name</th>
                <th style={{ ...headerCellStyle, width: '300px' }}>Last Name</th>
                <th style={{ ...headerCellStyle, width: '100px' }}>Gender</th>
                <th style={{ ...headerCellStyle, width: '300px' }}>Date Of Birth</th>
                <th style={{ ...headerCellStyle, width: '300px' }}>Phone No.</th>
                <th style={{ ...headerCellStyle, width: '100px' }}>Address 1</th>
                <th style={{ ...headerCellStyle, width: '300px' }}>Address 2</th>
                <th style={{ ...headerCellStyle, width: '300px' }}>City</th>
                <th style={{ ...headerCellStyle, width: '100px' }}>Pincode</th>
                <th style={{ ...headerCellStyle, width: '300px' }}>Role</th>
                <th style={{ ...headerCellStyle, width: '300px' }}>Department</th>
                <th style={{ ...headerCellStyle, width: '300px' }}>Subjects</th>
                <th style={{ ...headerCellStyle, width: '100px' }}>Date Of Join</th>
                <th style={{ ...headerCellStyle, width: '300px' }}>Employee Type</th>
                <th style={{ ...headerCellStyle, width: '300px' }}>Active</th>
                <th style={headerCellStyle}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {data
                .filter((row) =>
                  row.NAME.toLowerCase().includes(search.toLowerCase()) ||
                  row.CONTACTNO.toLowerCase().includes(search.toLowerCase())
                )
                .map((row, index) => (
                  <tr key={index}>
                    <td style={cellStyle}>{row.ID}</td>
                    <td style={cellStyle}>{row.NAME}</td>
                    <td style={cellStyle}>{row.LASTNAME}</td>
                    <td style={cellStyle}>{row.GENDER}</td>
                    <td style={cellStyle}>{row.DOB}</td>
                    <td style={cellStyle}>{row.CONTACTNO}</td>
                    <td style={cellStyle}>{row.ADDRESS1}</td>
                    <td style={cellStyle}>{row.ADDRESS2}</td>
                    <td style={cellStyle}>{row.CITY}</td>
                    <td style={cellStyle}>{row.PINCODE}</td>
                    <td style={cellStyle}>{row.ROLE}</td>
                    <td style={cellStyle}>{row.DEPARTMENT}</td>
                    <td style={cellStyle}>{row.SUBJECTS}</td>
                    <td style={cellStyle}>{row.DOJ}</td>
                    <td style={{...cellStyle,fontWeight:'bold',color:getColor(row.EMPLOYETYPE)}}>{row.EMPLOYETYPE}</td>
                    <td
  style={{
    ...cellStyle,
    textAlign: 'center',
   
  }}
>
  <div style={{backgroundColor: row.ACTIVE === 'Y' ? '#B1F58E' : '#FFC1B5',
    fontWeight:'bold',padding:'0',borderRadius:'5px',color:'#300242'}}>{row.ACTIVE === 'Y' ? 'ACTIVE' : 'IN-ACTIVE'}</div>
</td>
                    <td style={cellStyle}>
                      <button className="GridButton" onClick={() => handlePayClick(row)}>UPDATE</button>
                       <button className="GridButton" onClick={() => handleAssignClick(row)}>ASSIGN</button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      )}

      {selectedRow && Type=='Update' && (
        <div style={modalOverlayStyle}>
          <div style={modalStyle}>
            <div style={{ marginTop: '15px', textAlign: 'left',  fontSize: '16px' }}>
                  <div className="row">
    <div style={Header}>Staff Entry</div>
</div>
<br></br>
           
<div className="row">
                <div className='col-253'>
    <label style={{ backgroundColor: 'white',marginLeft:'0px' }} for="input" class="text">First Name</label>
     <div className="coolinput">
      <input
        style={{ backgroundColor: 'white',marginTop:'10px' }}
        type="text"
        name="FNAME"
        value={formData.FNAME}
        onChange={handleChange}
        autoComplete="off"
        className="input"
      />
    </div> 
  </div> 
   <div className='col-753'>
    <label style={{ backgroundColor: 'white',marginLeft:'0px' }} for="input" class="text">Last Name</label>
     <div className="coolinput">
      <input
        style={{ backgroundColor: 'white',marginTop:'10px' }}
        type="text"
        name="LNAME"
        value={formData.LNAME}
        onChange={handleChange}
        autoComplete="off"
        className="input"
      />
    </div> 
  </div> 
   <div className='col-753'>
    <label style={{ backgroundColor: 'white',marginLeft:'0px' }} for="input" class="text">Gender</label>
     <div className="coolinput" style={ComboBoxStyl}>
    <select type="text" placeholder="" name="GENDER"    value={formData.GENDER}
  onChange={handleChange}  autoComplete="off" class="input">
    <option value="">SELECT</option>
    <option value="MALE">MALE</option>
    <option value="FEMALE">FEMALE</option>
    <option value="OTHERS">OTHERS</option>
    </select>
    </div> 
  </div> 
</div>
<div className="row">
                <div className='col-253'>
    <label style={{ backgroundColor: 'white',marginLeft:'0px' }} for="input" class="text">Date Of Birth</label>
     <div className="coolinput">
      <input style={ComboBoxStyl}
              required
              type="date"
              name="DOB"
              autoComplete="off"
              className="input"
              value={formData.DOB}
              onChange={handleChange} 
            />
    </div> 
  </div> 
   <div className='col-753'>
    <label style={{ backgroundColor: 'white',marginLeft:'0px' }} for="input" class="text">Contact No.</label>
     <div className="coolinput">
      <input
        style={{ backgroundColor: 'white',marginTop:'10px' }}
        type="text"
        name="NUMBER"
        value={formData.NUMBER}
        onChange={handleChange}
        autoComplete="off"
        className="input"
      />
    </div> 
  </div> 
   <div className='col-753'>
    <label style={{ backgroundColor: 'white',marginLeft:'0px' }} for="input" class="text">Address-1</label>
     <div className="coolinput">
      <input
        style={{ backgroundColor: 'white',marginTop:'10px' }}
        type="text"
        name="ADDRESS1"
        value={formData.ADDRESS1}
        onChange={handleChange}
        autoComplete="off"
        className="input"
      />
    </div> 
  </div> 
</div>
<div className="row">
                <div className='col-253'>
    <label style={{ backgroundColor: 'white',marginLeft:'0px' }} for="input" class="text">Address-2</label>
     <div className="coolinput">
      <input
        style={{ backgroundColor: 'white',marginTop:'10px' }}
        type="text"
        name="ADDRESS2"
        value={formData.ADDRESS2}
        onChange={handleChange}
        autoComplete="off"
        className="input"
      />
    </div> 
  </div> 
   <div className='col-753'>
    <label style={{ backgroundColor: 'white',marginLeft:'0px' }} for="input" class="text">City</label>
     <div className="coolinput">
      <input
        style={{ backgroundColor: 'white',marginTop:'10px' }}
        type="text"
        name="CITY"
        value={formData.CITY}
        onChange={handleChange}
        autoComplete="off"
        className="input"
      />
    </div> 
  </div> 
   <div className='col-753'>
    <label style={{ backgroundColor: 'white',marginLeft:'0px' }} for="input" class="text">Pincode</label>
     <div className="coolinput">
      <input
        style={{ backgroundColor: 'white',marginTop:'10px' }}
        type="text"
        name="PINCODE"
        value={formData.PINCODE}
        onChange={handleChange}
        autoComplete="off"
        className="input"
      />
    </div> 
  </div> 
</div>
<div className="row">
                <div className='col-253'>
    <label style={{ backgroundColor: 'white',marginLeft:'0px' }} for="input" class="text">Position/Role</label>
     <div className="coolinput">
      <input
        style={{ backgroundColor: 'white',marginTop:'10px' }}
        type="text"
        name="POSITION"
        value={formData.POSITION}
        onChange={handleChange}
        autoComplete="off"
        className="input"
      />
    </div> 
  </div> 
   <div className='col-753'>
    <label style={{ backgroundColor: 'white',marginLeft:'0px' }} for="input" class="text">Department</label>
     <div className="coolinput">
      <input
        style={{ backgroundColor: 'white',marginTop:'10px' }}
        type="text"
        name="DEPARTMENT"
        value={formData.DEPARTMENT}
        onChange={handleChange}
        autoComplete="off"
        className="input"
      />
    </div> 
  </div> 
   <div className='col-753'>
    <label style={{ backgroundColor: 'white',marginLeft:'0px' }} for="input" class="text">Subject</label>
     <div className="coolinput">
      <input
        style={{ backgroundColor: 'white',marginTop:'10px' }}
        type="text"
        name="SUBJECTS"
        value={formData.SUBJECTS}
        onChange={handleChange}
        autoComplete="off"
        className="input"
      />
    </div> 
  </div> 
</div>
 <div className="row">
                <div className='col-253'>
    <label style={{ backgroundColor: 'white',marginLeft:'0px' }} for="input" class="text">Date Of Join</label>
     <div className="coolinput">
      <input style={ComboBoxStyl}
              required
              type="date"
              name="DOJ"
              autoComplete="off"
              className="input"
             value={formData.DOJ}
              onChange={handleChange} 
            />
    </div> 
  </div> 
   <div className='col-753'>
    <label style={{ backgroundColor: 'white',marginLeft:'0px' }} for="input" class="text">Employee Type</label>
     <div className="coolinput"  style={ComboBoxStyl}>
    <select type="text" placeholder="" name="EMPLOYEETYPE"    value={formData.EMPLOYEETYPE}
  onChange={handleChange}  autoComplete="off" class="input">
  <option value="">SELECT</option>
   {employeeTypes.map((type) => (
    <option key={type.value} value={type.value}>
      {type.label}
    </option>
  ))}
  </select>
    </div> 
  </div> 
   {/* <div className='col-753'>
    <label style={{ backgroundColor: 'white',marginLeft:'0px' }} for="input" class="text">Last Name</label>
     <div className="coolinput">
      <input
        style={{ backgroundColor: 'white',marginTop:'10px' }}
        type="text"
        name="STUDENTNAME"
        value={name}
        onChange={handleChange}
        autoComplete="off"
        className="input"
      />
    </div> 
  </div>  */}
</div>
            
  <div className="row">
           <div className="col-75">
        <label style={{backgroundColor:'white'}} for="input" class="text">Active</label>
            <div className="coolinput">
                
                  <label style={{ marginRight: '10px' }}>
              <input
                type="radio"
                name="SHIFT"
                value="Y"
                checked={formData.SHIFT === "Y"}
             onChange={handleShiftChange}
              />
              Yes
            </label>
            <label>
              <input
                type="radio"
                name="SHIFT"
                value="N"
                checked={formData.SHIFT === "N"}
                onChange={handleShiftChange}
              />
              No
            </label>

            
            </div> 
          </div> 
         
          </div>
                </div>
                <button onClick={handleSubmit} style={{ marginTop: '15px' }}>Save</button>
            <button onClick={handleCancel} style={{ marginTop: '15px' }}>Close</button>
          </div>
        </div>
      )}
  {selectedRow && Type=='Assign' && (
        <div style={{...modalOverlayStyle}}>
          <div style={{...modalStyle,height:'650px'}}>
            <div style={{ marginTop: '15px', textAlign: 'left',  fontSize: '16px' }}>
                  <div className="row">
    <div style={Header}>Staff Student Assign  {selectedRow.NAME+' [ '+selectedRow.ID+' ]'}</div>
</div>
<br></br>
  <div className="row">
     <div className="coolinput">
     <input
              type="text"
              placeholder="Search By Student Name/Student Id"
              name="STUDENTNAME"
              value={search1}
              onChange={(e) => setSearch1(e.target.value)}
              autoComplete="off"
              className="input"
            /></div>
</div>
<br></br>
         <div style={{ maxHeight: '300px', overflowY: 'auto', border: '1px solid #ccc' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ backgroundColor: '#f2f2f2' }}>
                <th style={{ ...headerCellStyle, width: '100px' }}>Student ID</th>
                <th style={{ ...headerCellStyle, width: '300px' }}>Name</th>
            
                <th style={{ ...headerCellStyle, width: '100px' }}>Class</th>
              
                <th style={{ ...headerCellStyle, width: '100px' }}>Tuition Due</th>
                <th style={{ ...headerCellStyle, width: '100px' }}>Transport Due</th>
                <th style={{ ...headerCellStyle, width: '100px' }}>
                  <input
                    type="checkbox"
                    checked={selectedStudents.length === Studdata.filter((row) =>
                      row.NAME.toLowerCase().includes(search1.toLowerCase()) ||
                      row.STUDENT_ID.toLowerCase().includes(search1.toLowerCase())
                    ).length}
                    onChange={handleSelectAllChange}
                  />
                </th>
                {/* <th style={{ ...headerCellStyle, width: '120px' }}>Actions</th> */}
              </tr>
            </thead>
            <tbody>
              {Studdata
                .filter((row) =>
                  row.NAME.toLowerCase().includes(search1.toLowerCase()) ||
                  row.STUDENT_ID.toLowerCase().includes(search1.toLowerCase())
                )
                .map((row, index) => (
                  <tr key={index}>
                    <td style={cellStyle}>{row.STUDENT_ID}</td>
                    <td style={cellStyle}>{row.NAME}</td>
            
                    <td style={cellStyle}>{row.CLASS_SEC}</td>
                
                    <td style={cellStyle}>{row.ACADEMIC_DUE}</td>
                    <td style={cellStyle}>{row.TRANSPORT_DUE}</td>
                    <td style={{ ...cellStyle, textAlign: 'center', verticalAlign: 'middle' }}>
                      <input
                        type="checkbox"
                        checked={selectedStudents.includes(row.STUDENT_ID)}
                        onChange={() => handleCheckboxChange(row.STUDENT_ID)}
                      />
                    </td>
                    {/* <td style={cellStyle}>
                      <button className="GridButton" onClick={() => handlePayClick(row)}>Pay</button>
                      <button className="GridButton" onClick={handleCancel}>Cancel</button>
                    </td> */}
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
                </div>
                <div style={{ textAlign: 'right'}}>
                <button className="GridButton" onClick={handleStudentSubmit}>Save</button>
           </div>
<br></br>
             <div style={{ maxHeight: '100px', overflowY: 'auto', border: '1px solid #ccc' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ backgroundColor: '#f2f2f2' }}>
                <th style={{ ...headerCellStyle, width: '100px' }}>Student ID</th>
                <th style={{ ...headerCellStyle, width: '300px' }}>Name</th>
            
                <th style={{ ...headerCellStyle, width: '100px' }}>Class</th>
              
               
                <th style={{ ...headerCellStyle, width: '100px' }}>
                  <input
                    type="checkbox"
                    checked={selectedStudents.length === Studdata1.filter((row) =>
                      row.NAME.toLowerCase().includes(search1.toLowerCase()) ||
                      row.STUDENT_ID.toLowerCase().includes(search1.toLowerCase())
                    ).length}
                    onChange={handleSelectAllChange1}
                  />
                </th>
                {/* <th style={{ ...headerCellStyle, width: '120px' }}>Actions</th> */}
              </tr>
            </thead>
            <tbody>
              {Studdata1
                .map((row, index) => (
                  <tr key={index}>
                    <td style={cellStyle}>{row.STUDENT_ID}</td>
                    <td style={cellStyle}>{row.NAME}</td>
            
                    <td style={cellStyle}>{row.CLASS}</td>
                
                    
                    <td style={{ ...cellStyle, textAlign: 'center', verticalAlign: 'middle' }}>
                      <input
                        type="checkbox"
                        checked={selectedStudents.includes(row.STUDENT_ID)}
                        onChange={() => handleCheckboxChange(row.STUDENT_ID)}
                      />
                    </td>
                    {/* <td style={cellStyle}>
                      <button className="GridButton" onClick={() => handlePayClick(row)}>Pay</button>
                      <button className="GridButton" onClick={handleCancel}>Cancel</button>
                    </td> */}
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
        <div style={{ textAlign: 'right'}}>
        <button className="GridButton"  onClick={handleStudentSubmit1} >Delete</button> <button className="GridButton" onClick={handleCancel} >Close</button>
        </div>
          </div>
        </div>
      )}

    </div>
  );
};

// Styles
const Header=
{
backgroundColor:'#E8E69E',
padding:'10px',textAlign:'center',
fontSize:'20px',fontWeight:'bold'

}

const ComboBoxStyl={
    backgroundColor:'white',marginTop:'10px'
}

const MastAddNewBtn=
{
    padding:10,
    backgroundColor:"#f0fc9f",
    color:'black'
}
const headerCellStyle = {
  border: '1px solid #ddd',
  padding: '8px',
  backgroundColor: '#f2f2f2',
  position: 'sticky',
  top: 0,
  zIndex: 1,
};

const cellStyle = {
  border: '1px solid #ddd',
padding: '2px',
  fontSize:'13px'
};

const modalOverlayStyle = {
  position: 'fixed',
  top: 0, left: 0, right: 0, bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 9999,
};

const modalStyle = {
  backgroundColor: 'white',
  padding: '20px',
  borderRadius: '8px',
  width: '550px',
  boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
  textAlign: 'center',
};

export default StaffMast;
